import EchartLine from './line.vue'
import EchartPie from './pie.vue'
import EchartBasic from './basic.vue'
export {
    EchartLine,
    EchartPie,
    EchartBasic
};